<script setup lang="ts">
import { useLanguage } from '#composables/useLanguage';
import { useUserStore } from '#stores/user.store';
import { computed, watch, type PropType } from 'vue';
import { useTimeRemainingInImpersonateSession } from './composables/useTimeRemainingInImpersonateSession';

const props = defineProps({
  sidebarState: { type: String as PropType<'none' | 'collapsed' | 'open'>, required: true }
});
const emits = defineEmits<{
  stopImpersonate: [];
}>();

const timeRemainingInSession = useTimeRemainingInImpersonateSession();
const { t } = useLanguage();

watch(timeRemainingInSession, (remaining) => {
  if (remaining && remaining.seconds <= 0) {
    emits('stopImpersonate');
  }
});

const fullWidthMinusSidebar = computed(() => ({
  'inset-x-0': props.sidebarState === 'none',
  'w-[calc(100%-theme(spacing[sidebar-width]))]': props.sidebarState === 'open',
  'w-[calc(100%-theme(spacing[sidebar-close]))]': props.sidebarState === 'collapsed'
}));

const userStore = useUserStore();
const userInfos = computed(() =>
  [
    userStore.authenticatedUser?.displayName,
    userStore.authenticatedUser?.scope?.organization.name,
    userStore.authenticatedUser?.scope?.organization.country
  ]
    .filter(Boolean)
    .join(' • ')
);
</script>

<template>
  <div class="h-screen w-impersonation-sideWidth bg-impersonation fixed top-0 z-50"></div>
  <div class="right-0 h-screen w-impersonation-sideWidth bg-impersonation fixed top-0 z-50"></div>
  <div class="h-impersonation-sideWidth bg-impersonation fixed bottom-0 z-50" :class="fullWidthMinusSidebar"></div>
  <div class="h-impersonation-height bg-impersonation fixed top-0 z-50" :class="fullWidthMinusSidebar">
    <div class="flex justify-center items-center h-full text-white text-sm">
      <div class="flex grow justify-center items-center gap-4">
        <img class="h-8 w-8 rounded-full bg-gray-50" :src="userStore.authenticatedUser?.avatarUrl" alt="" />
        {{ userInfos }}
        <button
          class="text-sm font-bold px-4 py-2 rounded border border-white border-rounded"
          @click="$emit('stopImpersonate')"
        >
          {{ t('admin.impersonateFrame.stop') }}
        </button>
      </div>
      <div v-if="timeRemainingInSession" class="p-4 space-x-2">
        <span>{{ t('impersonateFrame.timeRemaining') }}:</span
        ><span class="font-bold">{{ timeRemainingInSession.formated }}</span>
      </div>
    </div>
  </div>
</template>
